import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Radium } from 'higher-order-components'
import { SearchIcon, InputText } from 'components'
import { HAS_TOUCH } from 'constants/environment'
import COLOR_PALETTE from 'constants/color-palette'

class SearchInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.initialValue || ''
    }
    this.controlled = typeof props.value === 'string'
  }
  handleChange = ({ target: { value } }) => this.setState({ value })
  handleTouchSearch = () => {
    // This method is for touch devices only
    if (!HAS_TOUCH) return
    const { onClear, onSearch } = this.props
    const search = this.input.value
    if (search === '') {
      onClear && onClear()
    } else {
      onSearch && onSearch(search)
    }
  }
  handleClear = () => {
    const { onClear } = this.props
    this.setState({ value: '' }, () => {
      onClear && onClear()
    })
  }
  handleKeyUp = (e) => {
    if (e.key === 'Escape') {
      this.handleClear()
    }
  }
  handleKeyDown = (e) => {
    const { onSearch } = this.props
    const search = this.input.value
    if (e.key === 'Enter') {
      onSearch && onSearch(search)
    }
  }
  handleOnFocus = (e) => {
    this.setState({ focus: true })
    this.props.onFocus && this.props.onFocus(e)
  }
  handleOnBlur = (e) => {
    this.setState({ focus: false })
    this.props.onBlur && this.props.onBlur()
  }
  handleInnerRef = (e) => {
    this.input = e
    this.props.innerRef && this.props.innerRef(e)
  }
  handleOnChange = (e) => {
    // if input is not controlled update to state
    if (!this.controlled) {
      this.handleChange(e)
    }
    this.props.onChange && this.props.onChange(e)
  }
  componentDidMount() {
    // onSearch is not a valid html attribute in react
    this.input.addEventListener('search', this.handleTouchSearch)
  }

  componentWillUnmount() {
    this.input.removeEventListener('search', this.handleTouchSearch)
  }

  render() {
    const {
      hideIcon,
      onSearchIconClick,
      fadeOutInput,
      focusStyle = true,
      styleName = 'light',
      lineColor = COLOR_PALETTE.GRAY,
      placeholder
    } = this.props

    // use value from props if component is controlled
    const value = this.controlled ? this.props.value : this.state.value

    return (
      <div
        style={[
          styles.container,
          fadeOutInput
            ? { borderColor: 'transparent' }
            : focusStyle && this.state.focus ? styles.focus : { borderColor: lineColor }
        ]}>
        <div
          style={{
            height: '100%',
            display: 'flex'
          }}>
          <div
            onClick={onSearchIconClick}
            style={[
              styles.svgContainer,
              onSearchIconClick && styles.searchIconInteractive,
              hideIcon && { visibility: 'hidden' },
              {
                height: '1.2em',
                width: '1.2em',
                marginRight: '1em',
                paddingTop: '.5em'
              }
            ]}>
            <SearchIcon style={styles.svgBase} />
          </div>
        </div>
        <div
          style={[
            { width: '100%', transition: 'opacity .25s' },
            fadeOutInput && { opacity: 0 }
          ]}>
          <InputText
            placeholder={placeholder}
            value={value}
            margin={'0px'}
            autoComplete={'none'}
            showBorderBottom={false}
            icon={this.props.icon || ''}
            onIconClick={this.props.behaviour === 'close' ? onSearchIconClick : this.handleClear}
            type={this.props.type || 'search'}
            styleName={styleName}
            name="search"
            onKeyUp={this.handleKeyUp}
            onKeyDown={this.handleKeyDown}
            onBlur={this.handleOnBlur}
            onChange={this.handleOnChange}
            onFocus={this.handleOnFocus}
            innerRef={this.handleInnerRef} />
        </div>
      </div>
    )
  }
}

SearchInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  innerRef: PropTypes.func,
  onSearchIconClick: PropTypes.func,
  initialValue: PropTypes.string,
  styleName: PropTypes.string,
  hideIcon: PropTypes.bool,
  focusStyle: PropTypes.bool,
  onSearch: PropTypes.func,
  onClear: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  fadeOutInput: PropTypes.bool,
  lineColor: PropTypes.string
}

export default Radium(SearchInput)

const styles = {
  searchIconInteractive: {
    transition: 'color .25s',
    cursor: 'pointer',
    ':hover': {
      color: 'white'
    }
  },
  svgContainer: {
    position: 'relative',
    color: '#979797'
  },
  svgBase: {
    fill: 'currentColor',
    height: '100%',
    width: '100%'
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    transition: 'border-color .25s',
    borderBottom: '1px solid',
    padding: '0 .5em',
    boxSizing: 'border-box',
    width: '100%'
  },
  focus: {
    boxShadow: '0 1px 0 rgba(0, 0, 0, 0.06)'
  }
}



// WEBPACK FOOTER //
// ./src/components/form-elements/search-input/index.jsx